import { procurementAPI } from "../../axios";

export const actions = {
    GetAllBidActivity(context, data){
        return procurementAPI.get(`BidActivity/All`);
    },
    GetSingleBidActivity(context, data){
        return procurementAPI.get(`BidActivity/${data}`);
    },
    GetUniqueBidActivityReports(context){
        return procurementAPI.get(`BidActivity/Reports/Unique`);
    },
    UpdateBidActivity(context, data){
        return procurementAPI.put(`BidActivity/Update/${data.id}`, data);
    },
    DeleteBidActivity(context, data){
        return procurementAPI.delete(`BidActivity/Remove/${data}`);
    },
    CreateBidActivity(context, data){
        return procurementAPI.post(`BidActivity/Add`, data);
    },
    UpdateBidSort(context, data){
        return procurementAPI.post(`BidActivity/Update/Sort`, data);
    },
}